import { styled } from '@mui/material/styles';

export const InlineDiv = styled('div')({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  width: '100%',
  display: 'block',
  overflow: 'hidden',
});

export const WrapperTruncate = styled('div')({
  width: '100%',
});

export const InlineButton = styled('button')(({ theme }) => ({
  width: '100%',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  cursor: 'default',
  color: theme.palette.blue.dark,
  margin: 0,
  '&:focus': {
    outline: 'none',
    boxShadow: 'none',
  },
}));
